const isTestEnvironment = typeof process !== 'undefined' && process.env?.NODE_ENV === 'test';

export const getStaticCacheUrl = () => {
  if (isTestEnvironment) { return 'https://test-static-cache.inspired.com'; }
  return import.meta.env.VITE_STATIC_CACHE_URL;
};

export const isNonTestEnvironment = () => {
  return typeof process === 'undefined' || process.env?.NODE_ENV !== 'test';
};

export const getNodeEnv = () => {
  if (isTestEnvironment) { return 'test'; }
  return import.meta.env.VITE_NODE_ENV;
};

export const getMixpanelToken = () => {
  if (isTestEnvironment) { return 'test-mixpanel-token'; }
  return import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN;
};

export const getMixpanelHost = () => {
  if (isTestEnvironment) { return 'https://test-mixpanel-host.inspired.com'; }
  return import.meta.env.VITE_MIXPANEL_PROXY_HOST;
};

export const getScriptTagBaseUrl = () => {
  if (isTestEnvironment) { return 'https://test-script-tag.inspired.com'; }
  return import.meta.env.VITE_SCRIPT_TAG_BASE_URL;
};
